import { Rule } from 'antd/lib/form';
import FormInput from 'components/Input/FormInput';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

interface ILoginField {
	settingsId: string;
	onChange: (value: string) => void;
}

const LoginField: React.FC<ILoginField> = ({ onChange, settingsId }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterLogin') }], [t]);

	return (
		<FormInput
			testId="LoginField"
			name={`sbpLogin-${settingsId}`}
			label="loginLabel"
			onChange={onChange}
			validationRules={validationRules}
		/>
	);
};

export default React.memo(LoginField);
